import script from "./SummaryDetailItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryDetailItem.vue?vue&type=script&setup=true&lang=js"

import "./SummaryDetailItem.vue?vue&type=style&index=0&id=3da79208&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3da79208"]])

export default __exports__